<template>
    <b-container>
      
      <b-form @submit="onSubmit">
        <b-row class="justify-content-md-center">
          <b-col class="mt-2">
            <!-- <p style="font-size: 17px;color:#2284ab;">Verify Mobile</p> -->
            <p></p>
            <div style="padding: 10px;
                  border: 2px solid #c4c6be;
                  border-radius: 15px;">
              <b-form-group id="exampleInputGroup1" horizontal
                          label="Mobile No. <span style='color:red'>*</span>" label-size="sm">
                <b-form-input type="text" placeholder="Mobile Number" size="sm"
                            required v-model="form.mobile">
                </b-form-input>
              </b-form-group>
              <b-form-group id="exampleInputGroup1" horizontal v-if="otpsent"
                          label="OTP <span style='color:red'>*</span>" label-size="sm">
                <b-form-input type="text" placeholder="OTP" size="sm"
                            required v-model="form.otp">
                </b-form-input>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
          
        <b-row class="mt-2 justify-content-md-center">
          <b-col md="4" sm="12" style="text-align:center">
            <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
            <b-alert :show = "showDismissibleAlert" dismissible 
                @dismissed="showDismissibleAlert=false"
                
                :variant="variant">
                {{alertText}}
            </b-alert>
          </b-col>
          <b-col  md="8" sm="12" style="text-align:right" >
            <b-button type="submit" size="sm" variant="primary">{{btnText}}</b-button>
            <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
            <b-button variant="link" size="sm" @click="onClickButton" v-if="otpsent">Resend OTP</b-button>
          </b-col>
          </b-row>
      </b-form>
    </b-container>
</template>
<style>
.white-box {
  border: none;
  -webkit-box-shadow: 2px 9px 13px -6px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 9px 13px -6px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 9px 13px -6px rgba(0, 0, 0, 0.75);
}
.white-box a {
  color: #fff;
}
</style>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
export default {
  components:{Spinner},
  name: "DashboardClean",
  data() {
    return {
      form: {
        mobile: "",
        otp: ""
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      btnText: "Send OTP",
      otpsent: false
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.otpsent) {
        this.send_otp();
      } else {
        this.verify_otp();
      }
    },
    onClickButton(evt) {
      evt.preventDefault();
      this.send_otp();
    },
    send_otp() {
      this.isLoading = true;
      let promise = apis.SendOTP(this.form);

      promise
        .then(response => {
          if (response.status == 200) {
            this.otpsent = true;
            this.btnText = "Submit";
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Error while sending OTP";
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
        });
    },
    verify_otp() {
      this.isLoading = true;

      let promise = apis.VerifyOTP(this.form);
      promise
        .then(response => {
          if (response.status == 200) {
            this.$emit("verified", this.form.mobile, response.body);
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = "Error in Verifying OTP";
          this.variant = "danger";
          this.showDismissibleAlert = true;
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/GuardSurvey/OtpVerify.vue